export default __webpack_public_path__ + "static/media/crossout2.41d6a3c6.mp3";